var notes = {

    init: () => {
        
        const area = helper.element(".notes-message-wrapper");
        
        if (area) {
            helper.event(window, "resize", () => {
                notes.resize(area);
            });
            notes.resize(area);
        }

        
    },

    resize: (area) => {
        area.scrollTop = area.scrollHeight;
    }

};